// // VendorDashboard.jsx
// import React, { useState, useMemo } from 'react';
// import { Navigate, NavLink, useNavigate } from 'react-router-dom';
// import { mainRouteInitial } from '../../Data/Constant';
// import { useAreaData, useGetVendorDashboard, useShopDetailsData } from '../../API_Master/GetAPI';
// import Cookies from 'js-cookie';
// import { useDispatch } from 'react-redux';
// import { handleViewVendorListDetails } from '../../Redux/Slices/ProjectSlice';
// import VendorDashboardHeader from '../../Components/VendorDashboardHeader';
// import Select from 'react-select';

// const VendorDashboard = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { data: areaData = [] } = useAreaData();

//   const userId = Cookies.get('NIGHT_EYE_USER_ID');
//     const [selectedArea, setSelectedArea] = useState('');

//   const { data: dashboardSummary = [] } = useGetVendorDashboard(userId);
//   const { data: shops = [], isLoading } = useShopDetailsData(null, userId,selectedArea);

//   const areaOptions = areaData?.map(ele => ({
//     value: ele?.AreaID,
//     label: ele?.AreaName
//   }));

//   // Extract unique areas/zones for filter dropdown

//   // Filtered shops (area + search)

//   // Dashboard summary (first object or defaults)
//   const summary = dashboardSummary?.[0] || {
//     OverallShop: 0,
//     HelperCount: 0,
//     ViolanceCount: 0,
//     AmenitiesCount: 0
//   };

//   const selectStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       height: '48px',
//       width: '348px',
//       minHeight: '48px',
//       backgroundColor: 'rgb(241 245 249)',
//       borderColor: state.isFocused ? '#3B82F6' : 'rgb(203 213 225)',
//       boxShadow: state.isFocused ? '0 0 0 1px #3B82F6' : 'none',
//       borderRadius: '0.5rem',
//       '&:hover': { borderColor: '#3B82F6' },
//     }),
//     valueContainer: (provided) => ({ ...provided, padding: '0 16px' }),
//     singleValue: (provided) => ({ ...provided, color: '#0D141B' }),
//     placeholder: (provided) => ({ ...provided, color: '#94A3B8' }),
//   };

//   const handleViewShopDetails = (shop) => {
//     dispatch(handleViewVendorListDetails(shop?.ShopDetailID));
//     navigate(`/${mainRouteInitial}/MyShop`);
//   };

//   return (
//     <div>
//       <VendorDashboardHeader />

//       <div className="flex flex-col flex-1 w-full mx-auto px-4 md:px-8 py-8 space-y-8">
//         {/* Page Heading */}
//         <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
//           <div className="flex flex-col gap-1">
//             <h1 className="text-[#0d141b] dark:text-white text-3xl md:text-4xl font-black leading-tight tracking-[-0.033em]">
//               Vendor Details
//             </h1>
//           </div>
//           <button className="flex items-center gap-2 bg-primary hover:bg-blue-600 text-white px-5 py-2.5 rounded-lg font-bold text-sm transition-all shadow-lg shadow-blue-500/20">
//             <span className="material-symbols-outlined text-[20px]">add_business</span>
//             Register New Shop
//           </button>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//           <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
//             <div className="flex items-center gap-3">
//               <div className="p-2 bg-blue-50 dark:bg-blue-900/30 rounded-lg text-primary">
//                 <span className="material-symbols-outlined">storefront</span>
//               </div>
//               <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Total Shops</p>
//             </div>
//             <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">
//               {summary.OverallShop}
//             </p>
//           </div>

//           <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
//             <div className="flex items-center gap-3">
//               <div className="p-2 bg-red-50 dark:bg-red-900/30 rounded-lg text-red-600">
//                 <span className="material-symbols-outlined">warning</span>
//               </div>
//               <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Violations</p>
//             </div>
//             <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">
//               {summary.ViolanceCount}
//             </p>
//           </div>

//           <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
//             <div className="flex items-center gap-3">
//               <div className="p-2 bg-green-50 dark:bg-green-900/30 rounded-lg text-green-600">
//                 <span className="material-symbols-outlined">groups</span>
//               </div>
//               <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Total Helpers</p>
//             </div>
//             <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">
//               {summary.HelperCount}
//             </p>
//           </div>

//           <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
//             <div className="flex items-center gap-3">
//               <div className="p-2 bg-purple-50 dark:bg-purple-900/30 rounded-lg text-purple-600">
//                 <span className="material-symbols-outlined">lightbulb</span>
//               </div>
//               <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Amenities</p>
//             </div>
//             <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">
//               {summary.AmenitiesCount}
//             </p>
//           </div>
//         </div>

//         {/* Registered Shops Table with Filters */}
//         <div className="flex flex-col bg-white dark:bg-[#1a2632] rounded-xl border border-[#e7edf3] dark:border-gray-700 shadow-sm ">
//           {/* Toolbar */}
//           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 gap-4 border-b border-[#e7edf3] dark:border-gray-700">
//             <h3 className="text-[#0d141b] dark:text-white text-lg font-bold">
//               Registered Shops {shops.length > 0 && `(${shops.length})`}
//             </h3>

//             <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
//               {/* Search Input */}
//               {/* <label className="flex items-center flex-1 min-w-[240px] h-10 rounded-lg bg-[#f0f4f8] dark:bg-gray-800 px-3 border border-transparent focus-within:border-primary focus-within:ring-1 focus-within:ring-primary transition-all">
//                 <span className="material-symbols-outlined text-[#4c739a]">search</span>
//                 <input
//                   className="bg-transparent border-none text-sm w-full text-[#0d141b] dark:text-white placeholder-[#4c739a] focus:ring-0 outline-none"
//                   placeholder="Search by name, ID, area..."
//                   type="text"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </label> */}

//               {/* Area Filter Dropdown */}
//               {/* <select
//                 value={selectedArea}
//                 onChange={(e) => setSelectedArea(e.target.value)}
//                 className="h-10 px-3 rounded-lg bg-[#f0f4f8] dark:bg-gray-800 border border-transparent focus:border-primary focus:ring-1 focus:ring-primary text-sm text-[#0d141b] dark:text-white cursor-pointer min-w-[180px]"
//               >
//                 <option value="all">All Areas / Zones</option>
//                 {areaOptions.slice(1).map((area) => (
//                   <option key={area} value={area}>
//                     {area}
//                   </option>
//                 ))}
//               </select> */}
//               <Select
//                 options={[{label :"Select All",value:""},...areaOptions]}
//                 value={areaOptions.find((opt) => opt.value === selectedArea) || null}
//                 onChange={(opt) => {
//                    setSelectedArea(opt.value)
//                 }}
//                 placeholder={'Select Area'}
//                 styles={selectStyles}
//                 classNamePrefix="react-select"
//               />

//               {/* Optional Reset Button */}
//               {/* {(selectedArea !== 'all' || searchTerm) && (
//                 <button
//                   onClick={() => {
//                     setSelectedArea('');
//                     setSearchTerm('');
//                   }}
//                   className="text-sm text-primary hover:text-blue-700 font-medium"
//                 >
//                   Reset
//                 </button>
//               )} */}
//             </div>
//           </div>

//           {/* Table Header (desktop) */}
//           <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-gray-50 dark:bg-[#1e2a36] border-b border-[#e7edf3] dark:border-gray-700 text-xs font-bold text-[#4c739a] uppercase tracking-wider">
//             <div className="col-span-3">Shop Name & Type</div>
//             <div className="col-span-2">Area / Zone</div>
//             <div className="col-span-1">Status</div>
//             <div className="col-span-1">Helpers</div>
//             <div className="col-span-2">Timings</div>
//             <div className="col-span-3">Actions</div>
//           </div>

//           {/* Rows */}
//           {isLoading ? (
//             <div className="p-10 text-center text-gray-500 dark:text-gray-400">Loading shops...</div>
//           ) : shops.length === 0 ? (
//             <div className="p-10 text-center text-gray-500 dark:text-gray-400">
//               {shops.length === 0
//                 ? 'No shops registered yet'
//                 : 'No shops match the selected filters'}
//             </div>
//           ) : (
//             shops.map((shop) => (
//               <div
//                 key={shop.ShopDetailID}
//                 className="group flex flex-col md:grid md:grid-cols-12 gap-4 p-4 md:px-6 md:py-5 border-b border-[#e7edf3] dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors items-center"
//               >
//                 {/* Shop Name & Type */}
//                 <div className="col-span-3 flex items-center gap-4 w-full">
//                   <div
//                     className="size-12 rounded-lg bg-cover bg-center shrink-0 border border-gray-200 dark:border-gray-600"
//                     style={{
//                       backgroundImage: shop.ShopImage ? `url(/uploads/shop/${shop.ShopImage})` : 'none',
//                     }}
//                   >
//                     {!shop.ShopImage && (
//                       <div className="h-full flex items-center justify-center text-gray-400">
//                         <span className="material-symbols-outlined">store</span>
//                       </div>
//                     )}
//                   </div>
//                   <div className="flex flex-col">
//                     <p className="text-[#0d141b] dark:text-white font-bold text-base">
//                       {shop.ShopName || 'Unnamed Shop'}
//                     </p>
//                     <p className="text-[#4c739a] dark:text-gray-400 text-xs">{shop.Type}</p>
//                   </div>
//                 </div>

//                 {/* Area / Zone */}
//                 <div className="col-span-2 w-full">
//                   <p className="text-sm text-[#0d141b] dark:text-gray-200">
//                     {shop.AreaName || shop.CityName || '—'}
//                   </p>
//                   <p className="text-xs text-[#4c739a] dark:text-gray-400">{shop.ZoneName || '—'}</p>
//                 </div>

//                 {/* Status */}
//                 <div className="col-span-1 w-full flex md:block">
//                   <div
//                     className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${shop.ShopVerifiedStatus === 'true'
//                         ? 'bg-emerald-50 dark:bg-emerald-900/30 border border-emerald-100 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400'
//                         : 'bg-amber-50 dark:bg-amber-900/30 border border-amber-100 dark:border-amber-800 text-amber-700 dark:text-amber-400'
//                       }`}
//                   >
//                     <span
//                       className={`size-1.5 rounded-full ${shop.ShopVerifiedStatus === 'true' ? 'bg-emerald-600' : 'bg-amber-500'
//                         }`}
//                     />
//                     {shop.ShopVerifiedStatus === 'true' ? 'Verified' : 'Pending'}
//                   </div>
//                 </div>

//                 {/* Helpers */}
//                 <div className="col-span-1 w-full flex md:block">
//                   <div className="flex items-center gap-2 text-sm text-[#0d141b] dark:text-gray-200">
//                     <span className="material-symbols-outlined text-gray-400 text-[18px]">group</span>
//                     {shop.ShopHelperDetail?.filter((h) => h.IsActive)?.length || 0}
//                   </div>
//                 </div>

//                 {/* Timings */}
//                 <div className="col-span-2 w-full">
//                   <p className="text-sm text-[#0d141b] dark:text-gray-200">
//                     {shop.ShopOpenTime} – {shop.ShopCloseTime}
//                   </p>
//                 </div>

//                 {/* Actions */}
//                 <div className="col-span-3 flex flex-wrap gap-2 w-full mt-2 md:mt-0">
//                   <button
//                     onClick={() => handleViewShopDetails(shop)}
//                     className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-primary rounded-lg hover:bg-blue-600 shadow-sm shadow-blue-500/30 transition-colors"
//                   >
//                     <span className="material-symbols-outlined text-[16px]">visibility</span>
//                     View Details
//                   </button>
//                   <button className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-red-600 rounded-lg hover:bg-red-700 shadow-sm shadow-red-500/30 transition-colors">
//                     <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
//                     Daily Close
//                   </button>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VendorDashboard;

// VendorDashboard.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mainRouteInitial } from "../../Data/Constant";
import { useAreaData, useGetVendorDashboard, useUserShopDetailsData } from "../../API_Master/GetAPI";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { handleViewVendorListDetails } from "../../Redux/Slices/ProjectSlice";
import VendorDashboardHeader from "../../Components/VendorDashboardHeader";
import Select from "react-select";
import { NIGHT_EYE_IMG_URL } from "../../Process";
import DailyCloseModel from "../../Components/DailyCloseModel";

const VendorDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: areaData = [] } = useAreaData();
  const isUserShop = Cookies.get("NIGHT_EYE_USER_ROLE")?.toLowerCase() == "shopuser";
  const userId = Cookies.get("NIGHT_EYE_USER_ID");
  const [selectedArea, setSelectedArea] = useState("");

  const { data: dashboardSummary = [] } = useGetVendorDashboard(userId);
  const { data: shops = [], isLoading, refetch } = useUserShopDetailsData(null, userId, selectedArea);

  // ── Daily Close Modal States ───────────────────────────────────────
  const [showDailyCloseModal, setShowDailyCloseModal] = useState(false);
  const [selectedShopForClose, setSelectedShopForClose] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const areaOptions = areaData?.map((ele) => ({
    value: ele?.AreaID,
    label: ele?.AreaName,
  }));

  // Dashboard summary (first object or defaults)
  const summary = dashboardSummary?.[0] || {
    OverallShop: 0,
    HelperCount: 0,
    ViolanceCount: 0,
    AmenitiesCount: 0,
  };

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      height: "48px",
      width: "348px",
      minHeight: "48px",
      backgroundColor: "rgb(241 245 249)",
      borderColor: state.isFocused ? "#3B82F6" : "rgb(203 213 225)",
      boxShadow: state.isFocused ? "0 0 0 1px #3B82F6" : "none",
      borderRadius: "0.5rem",
      "&:hover": { borderColor: "#3B82F6" },
    }),
    valueContainer: (provided) => ({ ...provided, padding: "0 16px" }),
    singleValue: (provided) => ({ ...provided, color: "#0D141B" }),
    placeholder: (provided) => ({ ...provided, color: "#94A3B8" }),
  };

  const handleViewShopDetails = (shop) => {
    dispatch(handleViewVendorListDetails(shop?.ShopDetailID));
    navigate(`/${mainRouteInitial}/MyShop`);
  };

  // ── Daily Close Handlers ───────────────────────────────────────────
  const handleOpenDailyClose = (shop) => {
    setSelectedShopForClose(shop);
    setShowDailyCloseModal(true);
  };
  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  // const handleRegisterNewShop = () => {
  //   Cookies.set("IsStep1Completed", false)
  //   Cookies.set("IsStep2Completed", false)
  //   Cookies.set("IsStep3Completed", false)
  //   Cookies.remove("NIGHT_EYE_SHOP_DETAIL_ID")
  //   navigate(`/${mainRouteInitial}/VendorRegistration`)
  // }
  const onDailyCloseModelOff = () => {
    setShowDailyCloseModal(false);
    setSelectedShopForClose();
  };

  // ── JSX ─────────────────────────────────────────────────────────────
  return (
    <div>
      <VendorDashboardHeader />

      <div className="flex flex-col flex-1 w-full mx-auto px-4 md:px-8 py-8 space-y-8">
        {/* Page Heading */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <h1 className="text-[#0d141b] dark:text-white text-3xl md:text-4xl font-black leading-tight tracking-[-0.033em]">Vendor Details</h1>
          </div>
          {/* {isUserShop && <button 
          onClick={handleRegisterNewShop} className="flex items-center gap-2 bg-primary hover:bg-blue-600 text-white px-5 py-2.5 rounded-lg font-bold text-sm transition-all shadow-lg shadow-blue-500/20">
            <span className="material-symbols-outlined text-[20px]">add_business</span>
            Register New Shop
          </button>} */}
        </div>

        {/* Stats Cards */}
        {isUserShop && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-50 dark:bg-blue-900/30 rounded-lg text-primary">
                  <span className="material-symbols-outlined">storefront</span>
                </div>
                <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Total Shops</p>
              </div>
              <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">{summary.OverallShop}</p>
            </div>

            <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-red-50 dark:bg-red-900/30 rounded-lg text-red-600">
                  <span className="material-symbols-outlined">warning</span>
                </div>
                <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Violations</p>
              </div>
              <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">{summary.ViolanceCount}</p>
            </div>

            <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-green-50 dark:bg-green-900/30 rounded-lg text-green-600">
                  <span className="material-symbols-outlined">groups</span>
                </div>
                <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Total Helpers</p>
              </div>
              <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">{summary.HelperCount}</p>
            </div>

            <div className="flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-[#1a2632] border border-[#e7edf3] dark:border-gray-700 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-purple-50 dark:bg-purple-900/30 rounded-lg text-purple-600">
                  <span className="material-symbols-outlined">lightbulb</span>
                </div>
                <p className="text-[#4c739a] dark:text-gray-400 text-sm font-medium">Amenities</p>
              </div>
              <p className="text-[#0d141b] dark:text-white text-2xl font-bold leading-tight pl-1">{summary.AmenitiesCount}</p>
            </div>
          </div>
        )}

        {/* Registered Shops Table with Filters */}
        <div className="flex flex-col bg-white dark:bg-[#1a2632] rounded-xl border border-[#e7edf3] dark:border-gray-700 shadow-sm ">
          {/* Toolbar */}
          {/* {isUserShop &&   <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 gap-4 border-b border-[#e7edf3] dark:border-gray-700">
            <h3 className="text-[#0d141b] dark:text-white text-lg font-bold">
              Registered Shops {shops.length > 0 && `(${shops.length})`}
            </h3>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
              <Select
                options={[{ label: "Select All", value: "" }, ...areaOptions]}
                value={areaOptions.find((opt) => opt.value === selectedArea) || null}
                onChange={(opt) => {
                  setSelectedArea(opt?.value || '');
                }}
                placeholder={'Select Area'}
                styles={selectStyles}
                classNamePrefix="react-select"
              />
            </div>
          </div>} */}

          {/* Table Header (desktop) */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-gray-50 dark:bg-[#1e2a36] border-b border-[#e7edf3] dark:border-gray-700 text-xs font-bold text-[#4c739a] uppercase tracking-wider">
            <div className="col-span-3">Shop Name & Type</div>
            <div className="col-span-2">Area / Zone</div>
            <div className="col-span-1">Status</div>
            <div className="col-span-1">Helpers</div>
            <div className="col-span-2">Timings</div>
            <div className="col-span-3">Actions</div>
          </div>

          {/* Rows */}
          {isLoading ? (
            <div className="p-10 text-center text-gray-500 dark:text-gray-400">Loading shops...</div>
          ) : shops.length === 0 ? (
            <div className="p-10 text-center text-gray-500 dark:text-gray-400">{shops.length === 0 ? "No shops registered yet" : "No shops match the selected filters"}</div>
          ) : (
            shops.map((shop) => {
              const imageUrl = shop.ShopImage ? `${NIGHT_EYE_IMG_URL}/SmartCollection/ShopImage/${shop.ShopImage}` : null;

              return (
                <div
                  key={shop.ShopDetailID}
                  className="group flex flex-col md:grid md:grid-cols-12 gap-4 p-4 md:px-6 md:py-5 border-b border-[#e7edf3] dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors items-center"
                >
                  {/* Shop Name & Type */}
                  <div className="col-span-3 flex items-center gap-4 w-full">
                    {imageUrl && (
                      <div className="flex justify-end">
                        <div
                          className="size-10 rounded-lg bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 cursor-pointer overflow-hidden group relative"
                          onClick={() => openModal(imageUrl)}
                        >
                          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                            <span className="material-symbols-outlined text-white opacity-0 group-hover:opacity-100 text-xl">visibility</span>
                          </div>
                          <img
                            src={imageUrl}
                            alt="Shop close proof"
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.src = "/fallback-proof-placeholder.jpg"; // optional fallback
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {/* <div
                    className="size-12 rounded-lg bg-cover bg-center shrink-0 border border-gray-200 dark:border-gray-600"
                  // style={{
                  //   backgroundImage: shop.ShopImage ? `url(/uploads/shop/${shop.ShopImage})` : 'none',
                  // }}
                  >

                    {!shop.ShopImage && (
                      <div className="h-full flex items-center justify-center text-gray-400">
                        <span className="material-symbols-outlined">store</span>
                      </div>
                    )}
                  </div> */}
                    <div className="flex flex-col">
                      <p className="text-[#0d141b] dark:text-white font-bold text-base">{shop.ShopName || "Unnamed Shop"}</p>
                      <p className="text-[#4c739a] dark:text-gray-400 text-xs">{shop.Type}</p>
                    </div>
                  </div>

                  {/* Area / Zone */}
                  <div className="col-span-2 w-full">
                    <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.AreaName || shop.CityName || "—"}</p>
                    <p className="text-xs text-[#4c739a] dark:text-gray-400">{shop.ZoneName || "—"}</p>
                  </div>

                  {/* Status */}
                  <div className="col-span-1 w-full flex md:block">
                    <div
                      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${
                        shop.ShopVerifiedStatus === "true"
                          ? "bg-emerald-50 dark:bg-emerald-900/30 border border-emerald-100 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400"
                          : "bg-amber-50 dark:bg-amber-900/30 border border-amber-100 dark:border-amber-800 text-amber-700 dark:text-amber-400"
                      }`}
                    >
                      <span className={`size-1.5 rounded-full ${shop.ShopVerifiedStatus === "true" ? "bg-emerald-600" : "bg-amber-500"}`} />
                      {shop.ShopVerifiedStatus === "true" ? "Verified" : "Pending"}
                    </div>
                  </div>

                  {/* Helpers */}
                  <div className="col-span-1 w-full flex md:block">
                    <div className="flex items-center gap-2 text-sm text-[#0d141b] dark:text-gray-200">
                      <span className="material-symbols-outlined text-gray-400 text-[18px]">group</span>
                      {shop.ShopHelperDetail?.filter((h) => h.IsActive)?.length || 0}
                    </div>
                  </div>

                  {/* Timings */}
                  <div className="col-span-2 w-full">
                    <p className="text-sm text-[#0d141b] dark:text-gray-200">
                      {shop.ShopOpenTime} – {shop.ShopCloseTime}
                    </p>
                  </div>

                  {/* Actions */}
                  <div className="col-span-3 flex flex-wrap gap-2 w-full mt-2 md:mt-0">
                    <button
                      onClick={() => handleViewShopDetails(shop)}
                      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-primary rounded-lg hover:bg-blue-600 shadow-sm shadow-blue-500/30 transition-colors"
                    >
                      <span className="material-symbols-outlined text-[16px]">visibility</span>
                      View Details
                    </button>
                    <button
                      onClick={() => handleOpenDailyClose(shop)}
                      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-red-600 rounded-lg hover:bg-red-700 shadow-sm shadow-red-500/30 transition-colors"
                    >
                      <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
                      Daily Close
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* =================== DAILY CLOSE MODAL =================== */}
      {/* =================== DAILY CLOSE MODAL =================== */}
      {/* =================== DAILY CLOSE MODAL =================== */}

      {selectedShopForClose && <DailyCloseModel isOpen={showDailyCloseModal} onClose={onDailyCloseModelOff} selectedShop={selectedShopForClose} refetch={refetch} />}

      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={closeModal}>
          <div className="relative max-w-5xl max-h-[90vh] w-full h-full rounded-xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
            {/* Close button */}
            <button
              className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
              onClick={closeModal}
              aria-label="Close modal"
            >
              <span className="material-symbols-outlined">close</span>
            </button>

            {/* Image */}
            <img
              src={selectedImage}
              alt="Full size shop close proof"
              className="w-full h-full object-contain bg-slate-900"
              onError={(e) => {
                e.target.src = "/fallback-large-placeholder.jpg";
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorDashboard;
